import { LobbyWidget } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { useTranslation } from '@bonanza-social/i18n';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectReferrerPromo } from '@bonanza-social/promos';

function PromosLobbyWidget() {
  const [t] = useTranslation('inviteFriends');
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const referrerPromo = useSelector(selectReferrerPromo);

  const handleClick = () => {
    navigation.navigate('InviteFriends');
  };

  if (!referrerPromo) return null;

  return (
    <LobbyWidget
      image="inviteFriends.PostalEnvelope"
      label={t('inviteFriendsWidgetTitle')}
      onClick={handleClick}
    />
  );
}

export default memo(PromosLobbyWidget);
